import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import axios from 'axios';
import isToday from 'date-fns/is_today';

import {
  Button,
  Link,
  I18n,
  Status,
  TextInput,
  Checkbox,
} from 'components';
import { formatDate } from 'utils/formatString';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class NewAdressRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      code: '',
      isAgree: false,
    };
  }

  onCodeChange = (code) => this.setState({ code })

  sendConfirmation = async () => {
    const { reqExternalId, isLite } = this.props;
    const { code } = this.state;

    const endpoint = isLite
      ? '/api/profile/homeinternet/confirmMoveLite'
      : '/api/profile/homeinternet/confirmMoveNoLite';

    try {
      const { data } = await axios.post(endpoint, {
        reqExternalId,
        code,
      });

      if (data && data.result) {
        this.setState({ isSuccess: true });
      } else {
        this.setState({ isWrongCode: true, code: '' });
      }
    } catch (error) {
      this.setState({ isError: true });
    }
  }

  render() {
    const {
      isLite,
      newAddress,
      dateFrom,
    } = this.props;
    const {
      code,
      isAgree,
      isSuccess,
      isError,
      isWrongCode,
    } = this.state;

    if (isSuccess) {
      return (
        <Status className={['success', cx('component')]}>
          <I18n path="internet.newAddress.success" />
        </Status>
      );
    }

    if (isError) {
      return (
        <Status className={['error', cx('component')]} emoji="statusFail">
          <I18n path="common.operationFailed" />
          {'. '}
          <Link onClick={() => this.setState({ isError: false })}>
            <I18n path="common.retry" />
          </Link>
        </Status>
      );
    }

    return (
      <Status
        className={['attention', cx('component')]}
        emoji="statusFail"
      >
        <div className={cx('row')}>
          {isLite ? (
            <I18n
              path="internet.newAddress.messageLite"
              vars={{ address: newAddress }}
            />
          ) : (
            <I18n
              path={isToday(dateFrom)
                ? 'internet.newAddress.messageHardToday'
                : 'internet.newAddress.messageHardTomorrow'}
              vars={{
                address: newAddress,
                date: formatDate(dateFrom),
              }}
            />
          )}
        </div>

        {isLite ? (
          <>
            <div className={cx('row')}>
              <Checkbox
                className={cx('checkbox')}
                checked={isAgree}
                handleChange={() => this.setState({ isAgree: !isAgree })}
              >
                <I18n path="internet.newAddress.agreement" />
              </Checkbox>
            </div>
            <div className={cx('row')}>
              <Button
                onClick={this.sendConfirmation}
                disabled={!isAgree}
              >
                <I18n path="common.confirm" />
              </Button>
            </div>
          </>
        ) : (
          <>
            {isToday(dateFrom) && (
              <>
                <div className={cx('row')}>
                  <TextInput
                    className={cx('input')}
                    value={code}
                    onChange={this.onCodeChange}
                    placeholder="Код"
                    status={isWrongCode ? 'fail' : undefined}
                  />

                  {isWrongCode && (
                    <span className={cx('errorLabel')}>
                      Указан неверный код
                    </span>
                  )}
                </div>
                <div className={cx('row')}>
                  <Button
                    onClick={this.sendConfirmation}
                    disabled={!code}
                  >
                    <I18n path="common.confirm" />
                  </Button>
                </div>
              </>
            )}
          </>
        )}

        <div className={cx('row')}>
          <I18n path="internet.newAddress.support" />
        </div>
      </Status>
    );
  }
}

NewAdressRequest.propTypes = {
  isLite: PropTypes.bool,
  newAddress: PropTypes.string,
  dateFrom: PropTypes.string,
  reqExternalId: PropTypes.string,
};
